exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rate-header{\n    background-color: white;\n}\n", ""]);

// exports
